module.exports = "<lfwms-searchable-entity-search [serviceFactory]=\"serviceFactory\"></lfwms-searchable-entity-search>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-search/reports-configuration-search.component.html
// module id = ../../../../../src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-search/reports-configuration-search.component.html
// module chunks = main